import {BTTrackerBase} from './base';

// Taboola's documentation indicates they support the IAB Framework
// (https://help.taboola.com/hc/en-us/articles/360004904154-Taboola-s-Trust-Center#CCPA-1)
// however, testing reveals that the "uspAPI" is never queried for the "us_privacy" cookie
// so we'll proceed as though they do not support the IAB Framework
// meaning, page view and purchase events will not be fired for CA visitors that do not optin

export class TaboolaTracker extends BTTrackerBase {
  configure({taboolaAccountId, ...restParams}) {
    super.configure({taboolaAccountId, ...restParams});
    this.taboolaAccountId = taboolaAccountId;
  }

  getName() {
    return 'TaboolaTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  get restrictsEventsWithoutConsent() {
    return true;
  }

  init(...params) {
    if (!this.canInitialize()) {
      return false;
    }

    if (!this.taboolaAccountId) {
      this.log('Taboola disabled because no Account Id was specified.');
      this.disable();
      return false;
    }

    this.loadTag();

    super.init(...params);

    this.log('Taboola initialized', {taboolaAccountId: this.taboolaAccountId});

    return true;
  }

  loadTag() {
    // eslint-disable-next-line no-underscore-dangle
    window._tfa = window._tfa || [];

    // eslint-disable-next-line
    !(function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = 1; t.src = a; t.id = x; f.parentNode.insertBefore(t, f);
      }
    })(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      `//cdn.taboola.com/libtrc/unip/${this.taboolaAccountId}/tfa.js`,
      'tb_tfa_script');
  }

  // eslint-disable-next-line no-unused-vars
  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (addon) {
      this.log('Taboola purchase event will not fire for an add-on to an existing order.', {order, items, addon});
      return false;
    }

    if (!order) {
      this.log('Taboola purchase event will not fire when no order information provided.');
      return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    window._tfa.push({
      notify: 'event',
      name: 'make_purchase',
      id: this.taboolaAccountId,
      value: (order.subtotal + order.shipping).toFixed(2),
      currency: 'USD',
      orderid: order.id,
    });

    this.log('Taboola purchase event fired.', order);
    return true;
  }

  view() {
    if (!super.view()) {
      return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    window._tfa.push({
      notify: 'event',
      name: 'page_view',
      id: this.taboolaAccountId,
    });

    this.log('Taboola page view event fired.');

    return true;
  }
}
